import { useState, useCallback, useMemo } from 'react';
import { PolicyView } from '../../../../../../services/CaseManagementService';

/**
 * Hook for managing policy search and filtering
 */
export function usePolicySearch(policies: PolicyView[]) {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredPolicies = useMemo(() => {
    if (!searchTerm.trim()) {
      return policies;
    }

    const searchLower = searchTerm.toLowerCase();
    return policies.filter(
      (policy) =>
        policy.policyName?.toLowerCase().includes(searchLower) ||
        policy.policyNumber?.toLowerCase().includes(searchLower) ||
        policy.category?.toLowerCase().includes(searchLower) ||
        policy.company?.toLowerCase().includes(searchLower)
    );
  }, [policies, searchTerm]);

  const handleSearchChange = useCallback((value: string) => {
    setSearchTerm(value);
  }, []);

  const handleClearSearch = useCallback(() => {
    setSearchTerm('');
  }, []);

  return {
    searchTerm,
    filteredPolicies,
    handleSearchChange,
    handleClearSearch,
  };
}
